

import Vue from 'vue';
import { fetchUnionScale, fetchFindByUnion } from '@fetch';
import { unionFlag } from '../index';
import Cookies from 'js-cookie';

export default class Union {
  constructor() {
    this.unionCode = unionFlag() || sessionStorage.getItem('dffl_union');
  
    this.init();
  }

  init() {
    window.union_scale = 1;
    Vue.prototype.union_scale = 1;
    Vue.prototype.union_icon = '';
    Vue.prototype.union_name = TLang('福豆', 'my');

    window.ms_url =
      window.location.protocol +
      '//' +
      window.location.host.replace('corp.', '') +
      '/ms/' +
      window.location.search +
      '&returnUrl=' +
      encodeURIComponent(window.location.href);
    
    
    if (this.unionCode && this.unionCode === 'null') {
      sessionStorage.setItem('dffl_union', this.unionCode);
    } else if (!this.unionCode) {
      sessionStorage.removeItem('dffl_union');
    }
    
  }

  // 工会转换比例
  setUnionScale() {
    fetchUnionScale({
      unionFlag: this.unionCode ? 1 : 0,
      union: this.unionCode
    }).then(res => {
      Vue.prototype.union_scale = res.scale || 1;
      Vue.prototype.union_icon = res.icon;
      Vue.prototype.union_name = res.name || TLang('福豆', 'my');

      window.union_scale = res.scale;
      window.union_icon = res.icon;
      window.union_name = res.name || TLang('福豆', 'my');
    })
  }

  // 获取中英文标识
  findByUnion() {
    const address = Cookies.get('address') || '{}'
    fetchFindByUnion({
      city: address ? JSON.parse(address).cityId : "",
      union: this.unionCode,
      Business: false
    }).then(res => {
      const { mallUnionConfigDto = {} } = res;
      Vue.prototype.union_isBilingual = mallUnionConfigDto && mallUnionConfigDto.isBilingual;
    })
  }
}